import { useCurrentStateAndParams } from '@uirouter/react';
import { useEffect } from 'react';
import { useImmerAtom } from 'jotai-immer';
import { ngContext } from '../../../../core/services/ng.delegate';
import { pageStateGroupsCreateAtom } from '../groups_create_atoms';
import { pageStateVM } from '../groups_create_view_models';
import { ROUTE_CREATE } from '../../groups_const';

export const useGroupsCreateInit = (): void => {
    const route = useCurrentStateAndParams();
    const [_pageState, setPageState] = useImmerAtom(pageStateGroupsCreateAtom);

    // INIT
    useEffect(() => {
        setPageState(draft => {
            if (draft.init) {
                // get context from Angular
                const ctx = ngContext();
                draft.canEdit = !!ctx && !!ctx.User;

                // get mode / title / params from route
                draft.mode = route.state.name == ROUTE_CREATE ? 'CREATE' : 'UPDATE';
                draft.title = draft.mode === 'CREATE' ? 'Create Group' : 'Edit Group';
                draft.id = draft.mode === 'UPDATE' && !!route.params ? route.params.Id : '';

                // everything is settled off route
                draft.init = false;
                return draft;
            } else {
                return draft;
            }
        });

        // destroy
        return (): void => {
            setPageState(() => pageStateVM());
        };
    }, [route, setPageState]);
};
